const contactInfo = {
  address: "Levent Mah. Çamlık Cad. No:29 34330 Beşiktaş/İstanbul",
  phone: "+90 (212) 951 02 65",
  email: "destek@bucketlist.com.tr",
  workingHoursWeekdays: "10:00 - 17:00",
  workingHoursWeekends: false,
};

export default contactInfo;
